import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { urlRecuperarPoliza } from 'constants/urls';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import Loading from 'wrappers/Loading';
import { SEGUKIDS } from './constants';

const RecuperarPolizaKids = () => {
  //const dataUsuario = useUsuario();
  const { addWarningToast } = useCustomToast();
  const { id: idCotizacion, idPoliza, codProducto } = useQueryParams();
  const history = useHistory();

  const getData = useCallback(async () => {
    const Data = {
      idPoliza: idPoliza,
    };

    const response = await ApiKeyFetch.instance().post(urlRecuperarPoliza, Data);

    if (response.transaccion) {
      if (response.data.pasosActual === null) {
        addWarningToast('Esta póliza ya ha sido completada');
        return history.push('/listado-polizas');
      } else {
        let urlGoTo = response.data.pasosActual.goTo;
        if (response.data.pasosActual.orden === 5) {
          let url = `${urlGoTo}&codProducto=${codProducto}`;
          history.replace(url);
        } else {
          let urlComplete = `/kids${urlGoTo}&codProducto=${codProducto}`;

          if (urlComplete.startsWith(SEGUKIDS.urls.pagador)) {
            urlComplete = urlComplete.replace(SEGUKIDS.urls.pagador, '/facturacion/tipo-persona');
          }

          history.replace(urlComplete);
        }
      }
    } else {
      addWarningToast('Ha ocurrido un problema al recuperar la póliza');
      history.replace('/listado-polizas');
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Loading loading={true} message="Recuperando...">
      <h1>Recuperando...</h1>
    </Loading>
  );
};
export default RecuperarPolizaKids;
